module.exports = __webpack_public_path__ + "img/vertical_3_5_1.2cd9e73a.png";